import { useState } from 'react';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

function fmt(value) {
  if (value === null || value === undefined) return '$0';
  return '$' + parseFloat(value).toLocaleString('es-CO');
}

function SaldoWidget({ saldo }) {
  const isMobile = useIsMobile();
  const [minimized, setMinimized] = useState(() => {
    return localStorage.getItem('saldo_widget_minimized') === 'true';
  });

  if (!saldo) return null;

  const toggle = () => {
    const next = !minimized;
    setMinimized(next);
    localStorage.setItem('saldo_widget_minimized', next ? 'true' : 'false');
  };

  const widgetBase = {
    position: 'fixed',
    bottom: isMobile ? '16px' : '24px',
    right: isMobile ? '12px' : '24px',
    zIndex: 9999,
    fontFamily: 'system-ui, sans-serif',
  };

  if (minimized) {
    return (
      <div style={widgetBase}>
        <button
          onClick={toggle}
          title="Ver saldo"
          style={{
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            backgroundColor: theme.colors.primary,
            color: theme.colors.background,
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.2rem',
            fontWeight: '700',
            boxShadow: `0 2px 12px ${theme.colors.glowStrong}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          $
        </button>
      </div>
    );
  }

  const row = (label, value, isTotal) => (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isTotal ? '6px 0 0 0' : '3px 0',
      borderTop: isTotal ? `1px solid ${theme.colors.border}` : 'none',
      marginTop: isTotal ? '6px' : 0,
    }}>
      <span style={{ color: theme.colors.textMuted, fontSize: '0.75rem' }}>{label}</span>
      <span style={{
        color: isTotal ? theme.colors.primary : theme.colors.text,
        fontSize: isTotal ? '0.9rem' : '0.8rem',
        fontWeight: isTotal ? '700' : '400',
      }}>
        {value}
      </span>
    </div>
  );

  return (
    <div style={widgetBase}>
      <div style={{
        backgroundColor: theme.colors.surface,
        border: `1px solid ${theme.colors.border}`,
        borderRadius: '10px',
        padding: '12px 14px',
        width: isMobile ? '180px' : '210px',
        maxWidth: isMobile ? 'calc(100vw - 24px)' : 'none',
        boxSizing: 'border-box',
        boxShadow: `0 4px 16px ${theme.colors.glowStrong}`,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <span style={{ color: theme.colors.primary, fontSize: '0.78rem', fontWeight: '700', letterSpacing: '0.03em' }}>
            SALDO
          </span>
          <button
            onClick={toggle}
            title="Minimizar"
            style={{
              background: 'none',
              border: 'none',
              color: theme.colors.textMuted,
              cursor: 'pointer',
              fontSize: '1rem',
              lineHeight: 1,
              padding: '0 2px',
            }}
          >
            −
          </button>
        </div>
        {row('Saldo anterior', fmt(saldo.saldo_anterior))}
        {row('Bonos', fmt(saldo.valor_bono))}
        {row('Recargas', fmt(saldo.valor_recarga))}
        {row('Gasto plataforma', fmt(saldo.valor_gasto_plataforma))}
        {row('Gasto publicidad', fmt(saldo.valor_gasto_publicidad))}
        {row('Saldo actual', fmt(saldo.saldo_final), true)}
      </div>
    </div>
  );
}

export default SaldoWidget;
